class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelector("#CartDrawer-Overlay").addEventListener(
      "click",
      this.close.bind(this)
    );
    this.setHeaderCartIconAccessibility();

    this.prevDataWidth = null;
    this.handleMeter();

    this.init();
  }

  init() {
    if (
      document.body.contains(document.querySelector(".Cart__UpsellContainer"))
    ) {
      this.cartUpsell();
      this.cartUpsellSidebar();
    }
  }

  handleMeter() {
    const meterFill = this.querySelector(".Meter__Fill");
    if (meterFill) {
      this.prevDataWidth = meterFill.getAttribute("data-width");
      meterFill.style.transform = `translate(${this.prevDataWidth}, 0%) matrix(1, 0, 0, 1, 0, 0)`;
    }

    // Observe the container for changes
    const observer = new MutationObserver(() => {
      const meterFill = this.querySelector(".Meter__Fill");
      if (meterFill) {
        // Apply the previous data-width if we had one
        if (this.prevDataWidth !== null) {
          if (
            this.prevDataWidth !== meterFill.getAttribute("data-width") ||
            !meterFill.style.transform
          ) {
            // meterFill.setAttribute("data-width", this.prevDataWidth);
            meterFill.style.transform = `translate(${this.prevDataWidth}, 0%) matrix(1, 0, 0, 1, 0, 0)`;

            this.prevDataWidth = meterFill.getAttribute("data-width");

            // Optionally apply a CSS transform
            setTimeout(() => {
              meterFill.style.transition = "transform 0.3s ease-in-out";
              meterFill.style.transform = `translate(${this.prevDataWidth}, 0%) matrix(1, 0, 0, 1, 0, 0)`;
            }, 100);
          }
        }
      }
    });

    // Start observing the parent
    observer.observe(this, { childList: true, subtree: true });
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector("#cart-icon-bubble");
    cartLink.setAttribute("role", "button");
    cartLink.setAttribute("aria-haspopup", "dialog");
    // cartLink.addEventListener("click", (event) => {
    //   event.preventDefault();
    //   if (location.pathname !== "/cart") {
    //     this.open(cartLink);
    //   }
    // });
    // cartLink.addEventListener("keydown", (event) => {
    //   if (event.code.toUpperCase() === "SPACE") {
    //     event.preventDefault();
    //     if (location.pathname !== "/cart") {
    //       this.open(cartLink);
    //     }
    //   }
    // });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute("role"))
      this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add("animate", "active");
    });

    this.addEventListener(
      "transitionend",
      () => {
        const containerToTrapFocusOn = this.classList.contains("is-empty")
          ? this.querySelector(".drawer__inner-empty")
          : document.getElementById("CartDrawer");
        const focusElement =
          this.querySelector(".drawer__inner") ||
          this.querySelector(".drawer__close");
        if (containerToTrapFocusOn) {
          trapFocus(containerToTrapFocusOn, focusElement);
        }
      },
      { once: true }
    );

    document.body.classList.add("overflow-hidden");
  }

  close() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute("role", "button");
    cartDrawerNote.setAttribute("aria-expanded", "false");

    if (cartDrawerNote.nextElementSibling.getAttribute("id")) {
      cartDrawerNote.setAttribute(
        "aria-controls",
        cartDrawerNote.nextElementSibling.id
      );
    }

    cartDrawerNote.addEventListener("click", (event) => {
      event.currentTarget.setAttribute(
        "aria-expanded",
        !event.currentTarget.closest("details").hasAttribute("open")
      );
    });

    cartDrawerNote.parentElement.addEventListener("keyup", onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector(".drawer__inner").classList.contains("is-empty") &&
      this.querySelector(".drawer__inner").classList.remove("is-empty");
    this.productId = parsedState.id;

    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(
        parsedState?.sections?.[section.id] ?? parsedState,
        section.selector
      );
    });

    const cartDrawerItems = this.querySelector("cart-drawer-items");
    this.classList.remove("is-empty");
    if (cartDrawerItems.classList.contains("is-empty")) {
      this.classList.add("is-empty");
    }

    this.init();

    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener(
        "click",
        this.close.bind(this)
      );
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
      },
    ];
  }

  getSectionDOM(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  cartUpsell() {
    var toggleTrigger = this.querySelector(
        '[data-action="toggle-upsell-products"]'
      ),
      toggleTrigger1 = this.querySelectorAll(".Cart__UpsellProductItem"),
      toggleElem = this.querySelector(".Cart__UpsellProductList"),
      addToCartButton = this.querySelectorAll(
        ".AddToCartContainer .UpsellPdtItem"
      );

    var toggleElemParent = this.querySelector(".Cart__UpsellContainer");

    toggleTrigger.onclick = function (event) {
      event.preventDefault();
      toggleElem.classList.toggle("Open");
    };

    for (var i = 0; i < toggleTrigger1.length; i++) {
      var elem = toggleTrigger1[i];

      (function (index) {
        elem.onclick = function () {
          var elemHtml = this.innerHTML;
          toggleElem.classList.toggle("Open");
          // if (toggleTrigger.innerHTML != elemHtml) {
          //   toggleTrigger.innerHTML = elemHtml;
          // }
          // toggleTrigger.classList.add("Selected");
          removeClassFromPdtItems();
          // addToCartButton[index].classList.add("Selected");

          addToCartButton[index]
            .querySelector("form")
            .dispatchEvent(new Event("submit", { bubbles: true }));

          toggleElemParent.classList.remove("Active");
        };
      })(i);
    }
    function removeClassFromPdtItems() {
      for (var k = 0; k < addToCartButton.length; k++) {
        addToCartButton[k].classList.remove("Selected");
      }
    }
  }

  cartUpsellSidebar() {
    var drawerTrigger = this.querySelector(".UpsellDrawerTrigger"),
      toggleElemParent = this.querySelector(".Cart__UpsellContainer"),
      addToCartContainer = this.querySelector(".AddToCartContainer"),
      closeDrawer = this.querySelector(".UpsellDrawerClose");

    if (drawerTrigger) {
      drawerTrigger.onclick = function (event) {
        event.preventDefault();
        toggleElemParent?.classList.toggle("Active");
      };
    }
    if (closeDrawer) {
      closeDrawer.onclick = function () {
        toggleElemParent?.classList.remove("Active");
      };
    }
    if (addToCartContainer) {
      addToCartContainer.onclick = function () {
        toggleElemParent?.classList.remove("Active");
      };
    }
  }
}

customElements.define("cart-drawer", CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: "CartDrawer",
        section: "cart-drawer",
        selector: ".drawer__inner",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
    ];
  }
}

customElements.define("cart-drawer-items", CartDrawerItems);
